// removed by extract-text-webpack-plugin
module.exports = {"listDataBank":"_3zleEUsjpP-v050nwbzHlJ","alertMessage":"_1J3HLj0EsY-0DK-oHhkju-","list":"_1XyclpY7Kl76m6uZWm0rBN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Profile/Pages/ConfigOrganizer/style.css
// module id = 447
// module chunks = 38